import { render, staticRenderFns } from "./PasswordSet.vue?vue&type=template&id=23cb3ff7&scoped=true"
import script from "./PasswordSet.vue?vue&type=script&lang=js"
export * from "./PasswordSet.vue?vue&type=script&lang=js"
import style0 from "./PasswordSet.vue?vue&type=style&index=0&id=23cb3ff7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cb3ff7",
  null
  
)

export default component.exports